/**
 * Courts and Offices API client
 * Provides court codes and office codes for legal assistance forms
 */

import apiClient from '@/lib/api-client'

export interface Court {
  id: number
  court: string
  code: string
}

export interface Office {
  id: number
  office: string
  code: string
}

export const courtsApi = {
  /**
   * Get all courts with codes
   * Used in Representation Court/Appellate forms
   */
  getCourts: async (): Promise<Court[]> => {
    const response = await apiClient.get<Court[]>('/courts/courts')
    return response.data
  },

  /**
   * Get all offices with codes
   * Used in Labor Cases forms
   */
  getOffices: async (): Promise<Office[]> => {
    const response = await apiClient.get<Office[]>('/courts/offices')
    return response.data
  },

  /**
   * Get just office codes (for simpler dropdown)
   * Returns array of code strings
   */
  getOfficeCodes: async (): Promise<string[]> => {
    const response = await apiClient.get<string[]>('/courts/offices/codes')
    return response.data
  },
}
